"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterDrawer = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const StyledInlineFormGrid = (0, styled_components_1.default)(core_1.Grid) `
  h3 {
    font-size: 32px;
  }
  h5 {
    font-size: 14px;
  }
`;
const StyledDrawerContent = styled_components_1.default.div `
  padding: 20px;
  .spacer {
    flex: 1;
  }
  .header {
    margin-bottom: 8px;
    .title {
      display: flex;
      align-items: center;
    }
  }
  .actions {
    margin-top: 24px;
    & > :not(:first-child) {
      margin-left: 10px;
    }
  }
`;
const FilterDrawer = props => {
    const { open, className, width = 360, title = 'Filter', clearLabel = 'Clear All', filterLabel = 'Filter', onClose, onFilter, onClear } = props;
    return (react_1.default.createElement(core_1.Drawer, { keepMounted: true, anchor: 'right', open: open, className: className, onClose: onClose },
        react_1.default.createElement(StyledDrawerContent, { style: { width }, className: 'drawer-content' },
            react_1.default.createElement(core_1.Grid, { container: true, className: 'header' },
                react_1.default.createElement(core_1.Grid, { item: true, className: 'title' },
                    react_1.default.createElement(core_1.Typography, { variant: 'h6' }, title)),
                react_1.default.createElement("div", { className: 'spacer' }),
                react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.IconButton, { onClick: onClose },
                        react_1.default.createElement(icons_1.Close, null)))),
            react_1.default.createElement(StyledInlineFormGrid, { container: true, wrap: 'wrap', spacing: 2 }, props.children),
            react_1.default.createElement("div", { className: 'actions' },
                react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', onClick: onFilter }, filterLabel),
                react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'outlined', onClick: onClear }, clearLabel)))));
};
exports.FilterDrawer = FilterDrawer;
exports.default = exports.FilterDrawer;
//# sourceMappingURL=FilterDrawer.js.map